import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import {
  ProviderHealthCollection,
  WhatsappProviderAvailability,
  WhatsappProviderHealth,
  WhatsappProviderIncident,
} from "../interfaces/WhatsappProviderHealth";

type ApiCollection<T> =
  | T[]
  | {
      items?: T[];
      data?: T[];
      monitoringStartedAt?: string | null;
    };

function normalizeCollection<T>(payload: ApiCollection<T>): ProviderHealthCollection<T> {
  if (Array.isArray(payload)) {
    return { items: payload };
  }

  return {
    items: payload.items ?? payload.data ?? [],
    monitoringStartedAt: payload.monitoringStartedAt,
  };
}

function getAuthorization() {
  const token = validateToken();

  if (!token) {
    throw new Error("Sessão expirada. Entre novamente para consultar o monitoramento.");
  }

  return { Authorization: token.AuthStr };
}

export async function buscarSaudeProviderWhatsapp() {
  const response = await axios.get<ApiCollection<WhatsappProviderHealth>>(
    `${Globais.DOMINIOBACK}/whatsapp/provider-health`,
    { headers: getAuthorization() }
  );

  return normalizeCollection(response.data);
}

export async function buscarHistoricoProviderWhatsapp(take = 50) {
  const response = await axios.get<ApiCollection<WhatsappProviderIncident>>(
    `${Globais.DOMINIOBACK}/whatsapp/provider-health/history`,
    { headers: getAuthorization(), params: { take } }
  );

  return normalizeCollection(response.data);
}

export async function buscarDisponibilidadeProviderWhatsapp(months = 6) {
  const response = await axios.get<ApiCollection<WhatsappProviderAvailability>>(
    `${Globais.DOMINIOBACK}/whatsapp/provider-health/availability`,
    { headers: getAuthorization(), params: { months } }
  );

  return normalizeCollection(response.data);
}

export async function verificarProviderWhatsappAgora() {
  await axios.post(
    `${Globais.DOMINIOBACK}/whatsapp/provider-health/check`,
    {},
    { headers: getAuthorization() }
  );
}
